/**
 * Custom queries for fetching Pages filtered by contentfulMetadata tags
 * Used for BlogListing component to fetch blog pages by category tags
 */

import gql from 'graphql-tag';

import {BasePageFragment} from '@amblique/contentful/app/contentful/fragments/page/base-page.fragment';
import {BaseBlogFragment} from '@amblique/contentful/app/contentful/fragments/blog/base-blog.fragment';

/**
 * Get Pages filtered by contentfulMetadata tags for BlogListing
 * Fetches pages with "pageBlog" tag + optional category tags
 * Returns essential Blog metadata from mainRegionCollection
 */
export const getBlogListingPages = gql`
  ${BasePageFragment}
  ${BaseBlogFragment}

  query GetBlogListingPages(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [PageOrder]
    $where: PageFilter
    $preview: Boolean
  ) {
    pageCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BasePageFragment
        mainRegionCollection {
          items {
            __typename
            ... on Blog {
              ...BaseBlogFragment
              blogTileImage {
                __typename
                ... on Image {
                  desktopAsset {
                    url
                  }
                  tabletAsset {
                    url
                  }
                  mobileAsset {
                    url
                  }
                  url
                }
                ... on ShopTheLook {
                  sys {
                    id
                  }
                  imageUrl
                }
              }
            }
          }
        }
        contentfulMetadata {
          tags {
            id
            name
          }
        }
      }
    }
  }
`;
